import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArticleList from '../article-list';
import Button from '@material-ui/core/Button';
import article from '../article-list/article';
import { map } from 'core-js/fn/array';
import Grid from '@material-ui/core/Grid';
import { CircularProgress, Typography } from '@material-ui/core';

function groupBy(list, props) {
  return list.reduce((a, b) => {
    const result = a;
    (result[b[props]] = result[b[props]] || []).push(b);
    return result;
  }, {});
}

class Sidebar extends Component {

  getArticleList(articles) {
    const { localSettings, productionPlaces, classes } = this.props;

    const groupByProductionPlaces = !!localSettings.showProductionPlaceFilter;
    const groupByState = !!localSettings.splitByState;
    const sideDishGroups = !!localSettings.sideDishGroups;
    
    if (sideDishGroups) {
      const groups = groupBy(articles, 'name');      
      return Object.keys(groups).map((groupKey) => {        
        return (
          <div>    
            <div className={classes.articleContainer}>
              <Typography className={classes.quantity}>{groups[groupKey].reduce((acc, x) => x.quantity + acc, 0)}</Typography>
              <>
                <Typography className={classes.name}>
                  {groupKey}
                </Typography>
              </>        
            </div>  
            {groups[groupKey].length > 1 || (groups[groupKey] && groups[groupKey][0].features.length > 1)  ? (
              <ArticleList 
                labelPrinting={localSettings.labelPrinting}             
                value={groups[groupKey]
                  .sort((a, b) => a.features.join(', ').localeCompare(b.features.join(', ')))
                  .map(x => ({...x, name: x.features.join(', '), features: []}))
                }
              />
            ) : null}                                                         
          </div>
        );
      });
    }

    if (groupByState) {
      const groups = groupBy(articles, 'stateName');      
      return Object.keys(groups).map((groupKey) => {        
        return (
          <div>
            <h2>{groupKey}</h2>
            <ArticleList 
              labelPrinting={localSettings.labelPrinting}             
              value={groups[groupKey]}
            />
          </div>
        );
      });
    }

    if (groupByProductionPlaces) {
      const groups = groupBy(articles, 'productionPlaceId');

      return Object.keys(groups).map((groupKey) => {
        const productionPlace = productionPlaces.find(x => x.productionPlaceId == groupKey);
        return (
          <div>
            <h2>{productionPlace ? productionPlace.name : ''}</h2>
            <ArticleList 
              labelPrinting={localSettings.labelPrinting}             
              value={groups[groupKey]}
            />
          </div>
        );
      })
    }

    return (
      <ArticleList
        labelPrinting={localSettings.labelPrinting}             
        value={articles}
      />
    );
  }
  render() {
    const { localSettings, 
      classes, 
      printArticleList, 
      isEPosPrinterEnabled, 
      showPrintAllOrders, 
      proceedAllVisibleOrders, 
      proceedingOrders, 
      isExpanded,
      toggleSidebar } = this.props;

    // const articleCounts = this.props.orders
    //   .flatMap(o => o.articles)
    //   .reduce((accumulator, current) => {
    //     const currentValue = accumulator[current.name] || 0;
    //     // eslint-disable-next-line no-param-reassign
    //     accumulator[current.name] = currentValue + current.quantity;
    //     return accumulator;
    //   }, {});

    // const articles = Object.keys(articleCounts).map(k => ({
    //   name: k,
    //   quantity: articleCounts[k],
    // }));


    const splitOutFeatures = localSettings && localSettings.splitSideDishes;
    const sideDishGroups = localSettings && localSettings.sideDishGroups;

    const articlemap = new Map();

    this.props.orders
      .forEach(order =>
        order.articles.forEach((article) => {
          const articlefeatures = article.features ? article.features.join(', ') : null;
          
          const articleKey = (article.name || '').trim();
          const articlenNameWithFeatures = (articleKey + articlefeatures).trim();

          let key = splitOutFeatures
          ? articleKey 
          : articlenNameWithFeatures;

          let currentValue = articlemap.get(key);                        

          if (typeof currentValue === 'undefined') {
            currentValue = {
              name: articleKey,
              features: splitOutFeatures ? [] : article.features,
              quantity: 0,
              labelPrintCount: 0,
              entries: [],
              stateName: article.stateName,
              productionPlaceId: article.productionPlaceId || order.productionPlaceId,
            };
          }

          currentValue.entries.push({
            id: article.id,
            quantity: article.quantity || article.amount || 1,
            labelPrintCount: article.labelPrintCount,
          }),

          
          currentValue.labelPrintCount += (article.labelPrintCount || 0);
          currentValue.quantity += (article.quantity || article.amount || 1);

          if (splitOutFeatures && article.featuresUnmapped) {
            article.featuresUnmapped.forEach((feature) => {
              const featureKey = feature.feature + feature.value;
              let currentFeature = articlemap.get(featureKey);

              if (typeof currentFeature === 'undefined') {               
                currentFeature = {
                  name: feature.value || feature.feature || '',
                  features: [],
                  quantity: 0,
                  productionPlaceId: article.productionPlaceId || order.productionPlaceId,
                };
              }

              currentFeature.quantity += feature.amount;

              articlemap.set(featureKey, currentFeature);
            });
          }

          articlemap.set(key, currentValue);
        }),
      );

    const articles = [];

    for (const article of articlemap.values()) {
      articles.push({
        name: article.name,
        quantity: article.quantity,
        features: article.features,
        entries: article.entries,
        labelPrintCount: article.labelPrintCount,
        productionPlaceId: article.productionPlaceId,
        stateName: article.stateName,
      });
    }

    return (
      <div className={classes.root} >
        {localSettings.splitByState
          ? (
            <div className={classes.hideToggle} onClick={toggleSidebar}>
              <div>
                {isExpanded ? '>' : '<'}
              </div> 
            </div>
          )
          : null
        }        
        <div
          className={classes.articleList}
        >
          {this.getArticleList(articles)}
        </div>

        {
          showPrintAllOrders ?
          (
            <div className={classes.buttonsContainer}>
              <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={() => proceedAllVisibleOrders()}
                  >{proceedingOrders 
                    ? 
                    (<CircularProgress size={25} />)
    
                    : 'Alle Bestellungen drucken'}</Button>              
            </div>
          )
          : null
        }
        {isEPosPrinterEnabled ?
          <div className={classes.buttonsContainer}>
            <Button
              variant="outlined"
              className={classes.button}
              onClick={() => printArticleList(articles)}
            >Artikelliste drucken</Button>
            {/* {this.renderRouteButtons()} */}
          </div>
          : null}
      </div>
    );
  }

  // renderRouteButtons() {
  //   const { classes, selectedMode, editRoutePlanning, finishRoutePlanning, isRoutePlanning, openRouteDialog } = this.props;
  //   if (selectedMode === "Route") {
  //     return (
  //       <div className={classes.routeButtonsContainer}>
  //         <Button
  //           variant="outlined"
  //           className={classes.button}
  //           onClick={isRoutePlanning ? finishRoutePlanning : editRoutePlanning}
  //         >{isRoutePlanning ? "Route speichern" : "Route bearbeiten"}
  //         </Button>
  //         <Button
  //           variant="outlined"
  //           className={classes.button}
  //           onClick={() => {
  //             if (isRoutePlanning)
  //               finishRoutePlanning()

  //             openRouteDialog();

  //           }}
  //         >Route berechnen
  //       </Button>
  //       </div>
  //     );
  // }
  // }
}

const styles = theme => ({
  root: {
    "box-shadow": "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
     "background-color": "#fff",
    display: 'flex',
    'flex-direction': 'column',
    height: `calc(100vh - ${theme.header.height}px )`,
    justifyContent: 'space-between',
    borderLeft: '1px solid lightgray',
    paddingLeft: '10px',
  },
  articleContainer: {
    display: 'flex',
    flex: 1,
    width: "100%",
    paddingLeft: '10px',
    marginTop: '20px',
    justifyContent: "space-between",
    fontWeight: 'bold',
    fontSize: '1.2em',
  },
  quantity: {
    width: theme.article.quantityWidth,
    fontWeight: 'bold',
    paddingLeft: '5px',
    textAlign: 'left',
  },
  name: {
    flex: 10,
    paddingLeft: '5px',
    fontWeight: 'bold',
  },
  hideToggle: {
    position: 'absolute',
    "box-shadow": "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    width: '40px',
    height: '40px',
    backgroundColor: 'white',
    borderRadius: '20px',
    marginLeft: '-25px',
    bottom: 70,
    zIndex: '1000',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    display: 'flex',
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  articleList: {
    // "flex-basis": "100%",
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  button: {
    fontSize: theme.order.buttons.fontSize,
    margin: '2px',
    flexGrow: 1,
  },
  routeButtonsContainer: {
    display: 'flex',
  },
  buttonsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  orders: PropTypes.array.isRequired,
  productionPlaces: PropTypes.array.isRequired,
  selectedMode: PropTypes.string.isRequired,
  finishRoutePlanning: PropTypes.func.isRequired,
  editRoutePlanning: PropTypes.func.isRequired,
  isRoutePlanning: PropTypes.bool.isRequired,
  openRouteDialog: PropTypes.func.isRequired,
  isEPosPrinterEnabled: PropTypes.bool.isRequired,
  localSettings: PropTypes.object.isRequired,
  proceedAllVisibleOrders: PropTypes.func.isRequired,
};


export default withStyles(styles)(Sidebar);
